export type AppAction = 'scale' | 'stop' | 'start' | 'redeploy' | 'change-domain' | 'delete';

/** Exact (lowercase) status values that mean a container or app is live. Shared by app, container and dashboard logic. */
export const RUNNING_STATUSES: readonly string[] = ['running', 'healthy', 'unhealthy', 'starting'];

export function isRunningApp(status: string | null | undefined): boolean {
  return RUNNING_STATUSES.includes((status ?? '').trim().toLowerCase());
}

/** Actions offered for an app in the given status, in display order. */
export function availableActions(status: string | null | undefined): AppAction[] {
  const s = (status ?? '').trim().toLowerCase();
  if (isRunningApp(s)) return ['scale', 'redeploy', 'change-domain', 'stop', 'delete'];
  if (s === 'stopped') return ['start', 'redeploy', 'delete'];
  if (s === 'failed') return ['redeploy', 'delete'];
  return []; // pending / unknown: nothing safe to do
}

export function isDestructive(action: AppAction): boolean {
  return action === 'delete' || action === 'stop';
}
